export const areDateYear = (number: number) => {
  return (number >= 2022 && number <= new Date().getFullYear() + 1) || [2018, 2019].includes(number)
}
